<script setup>
import { useRouter } from 'vue-router'
import TitleTwo from '@/components/title-des/titleTwo.vue'
const brainData = [
  {
    title: '产业研究',
    des: '利用人工智能大模型和大数据技术，为区域产业发展提供深度研究和战略指引',
    heart: [
      '区域产业发展规划研究',
      '创新应用场景体系研究',
      '哒达产研智编-web',
      '哒达产业图普-APP',
      '区域招商引资发展规划',
      '区域产业图谱研究分析',
    ],
    icon: 'https://static.idicc.cn/cdn/official/H5/home_card_top1.png',
    img: 'https://static.idicc.cn/cdn/official/H5/home_card_1.png',
    id: '/product/industryResearch',
  },
  {
    title: '产业招商',
    des: '精准匹配产业资源，助力全国区县实现高效招商引资和产业转型升级',
    heart: [
      '全量产业数据',
      '专属区域数据',
      '六大招商模型',
      '哒达助招',
      '每日优企智推',
    ],
    icon: 'https://static.idicc.cn/cdn/official/H5/home_card_top2.png',
    img: 'https://static.idicc.cn/cdn/official/H5/home_card_2.png',
    id: '/product/attractInvestment',  
  },
  {
    title: '产业出海',
    des: '搭建国际产业合作桥梁，助力企业拓展全球市场，实现国际化发展。',
    heart: [
      '智问——企业出海“秘书”',
      '智策——出海规划“大脑”',
      '智服——产业出海“服务”',
    ],
    icon: 'https://static.idicc.cn/cdn/official/H5/home_card_top3.png',
    img: 'https://static.idicc.cn/cdn/official/H5/home_card_3.png',
    id: '/toSea',
  },
]
const router = useRouter()
const jumpTo = (id) => {
  router.push({
    path: id,
  })
}
</script>

<template>
  <div class="brainPart w-full h-[830px]">
    <div class="bg-left-right flex flex-wrap flex-col">
      <TitleTwo
        title="三大主营业务"
        top="16px"
        bottom="30px"
        sub-title="专业的产业服务，助力区域经济高质量发展"
      />
      <div class="w-full h-[606px] overflow-x-scroll">
        <div class="w-[1536px] h-[606px] scrollBar px-[30px] flex items-center">
          <div
            v-for="brain in brainData"
            :key="brain.id"
            class="w-[480px] h-[606px] brainCards bg-white rounded-[16px] relative"
          >
            <div class="flex items-center justify-between">
              <div
                class="w-[62px] h-[62px] rounded-[12px] flex items-center justify-center"
                :style="{
                  background:
                    'linear-gradient( 180deg, #6BF3FF 0%, #1741CD 100%)',
                }"
              >
                <img :src="brain.icon" alt="" class="w-[32px] h-[32px]">
              </div>
              <div class="text-[28px] text-[#1741CD] flex items-center" @click="jumpTo(brain.id)">
                了解更多
                <img
                  src="https://static.idicc.cn/cdn/official/H5/home_blue_r.png"
                  alt=""
                  class="w-[32px] h-[32px]"
                >
              </div>
            </div>
            <div class="text-[28px] font-bold text-[#333333] my-3">
              {{ brain.title }}
            </div>
            <div class="text-[24px] text-[#666666]">
              {{ brain.des }}
            </div>
            <img
              :src="brain.img"
              alt=""
              class="w-[240px] h-[240px] absolute right-0 bottom-0"
            >
            <div class="text-[28px] text-[#333333] font-bold my-2">
              核心服务
            </div>
            <div
              v-for="txt in brain.heart"
              :key="txt"
              class="flex my-1 items-center relative z-1"
            >
              <div class="w-[12px] h-[12px] bg-[#1741CD] mr-1 rounded-[50%]" />
              <div class="text-[24px] text-[#666666]">
                {{ txt }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.brainPart {
  .bg-left-right {
    width: 100%;
    height: 100%;
    background: center / contain no-repeat
      url("https://static.idicc.cn/cdn/official/H5/home_main_bg.png");
    background-size: 100%;
  }

  .brainCards {
    margin-right: 24px;
    padding: 24px;
    box-sizing: border-box;

    .brainCardsDes {
      color: #999999;
      margin-top: 12px;
      padding: 8px 8px 0px 8px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
  }
}
</style>
